import { render, staticRenderFns } from "./haokaOrder copy.vue?vue&type=template&id=81a518b0&scoped=true&"
import script from "./haokaOrder copy.vue?vue&type=script&lang=js&"
export * from "./haokaOrder copy.vue?vue&type=script&lang=js&"
import style0 from "./haokaOrder copy.vue?vue&type=style&index=0&id=81a518b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a518b0",
  null
  
)

export default component.exports